const EsqueciSenha = () => {

    return (
        <div>Esqueci Senha</div>
    );
}

export default EsqueciSenha;